import Button from "../F7/Button";
import SaveButton from "../F7/SaveButton";
import { FC } from "react";

const Buttons: FC<{
  saveText?: string;
  cancelText?: string;
  onSave?: () => void;
  onCancel?: () => void;
}> = ({ saveText, cancelText, onSave, onCancel }) => {
  const css = {
    paddingLeft: 14,
    paddingRight: 14,
  };

  if (onSave && onCancel) {
    return (
      <div className="row" style={css}>
        <div className="col-50">
          <SaveButton onSave={onSave}>{saveText}</SaveButton>
        </div>
        <div className="col-50">
          <Button onClick={onCancel}>{cancelText}</Button>
        </div>
      </div>
    );
  } else if (onCancel) {
    return (
      <div className="row" style={css}>
        <div className="col-50">
          <Button onClick={onCancel}>{cancelText}</Button>
        </div>
      </div>
    );
  } else if (onSave) {
    return (
      <div className="row" style={css}>
        <div className="col-50">
          <SaveButton onSave={onSave}>{saveText}</SaveButton>
        </div>
      </div>
    );
  } else {
    throw new Error("At least on button must be enabled");
  }
};

Buttons.defaultProps = {
  saveText: "Save",
  cancelText: "Cancel",
};

export default Buttons;
